import { css } from '@/styled-system/css';

export const containerStyles = css.raw({
  width: '100%',
  maxWidth: 'breakpoint-xxl',
  marginInline: 'auto',
  paddingInline: { base: 'device.margin.mobile', md: 'device.margin.tablet', xl: 'device.margin.desktop' },
});

export const headerStyles = css.raw({
  width: '100%',
  maxWidth: 'breakpoint-xxl',
  marginInline: 'auto',
  // Modal.Header overrides
  paddingInlineStart: { base: 'device.margin.mobile', md: 'device.margin.tablet', xl: 'device.margin.desktop' },
  paddingInlineEnd: { base: 'device.margin.mobile', md: 'device.margin.tablet', xl: 'device.margin.desktop' },
  paddingBlock: { base: 'layout.tight', md: 'layout.default' },
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 'layout.tight',
});

export const footerStyles = css.raw({
  paddingInline: 'none',
  paddingBlock: { base: 'layout.tight', md: 'layout.default' },
  display: 'block',
});

export const stepperSlotStyles = css.raw({
  display: 'block',
  marginBlockEnd: { base: 'layout.loose', md: 'layout.looser' },
});
